import { createStore, createHook } from "react-sweet-state";
import { getScheduleApi } from "../api";
import { toast } from "react-toastify";

const Store = createStore({
  // value of the store on initialisation
  initialState: {
    isLoading: false,
    data: {
      _id: "",
      date: 20210000,
      exception: "",
      personId: "",
      personName: "",
      personNo: "",
      shift: {
        _id: "",
        code: "",
        description: "",
        checkIn: {
          location: "",
          timeRange: [1000,1000]
        },
        checkOut: {
          location: "",
          timeRange: [1000,1000]
        }
      }
    },
    error: null,
  },
  // actions that trigger store mutation
  actions: {
    findData:
      (personId, date) =>
      async ({ setState, getState }) => {
        setState({ isLoading: true, form: {} });

        try {
          const resp = await getScheduleApi({personId, date});

          if (resp.data && resp.data.code === 200) {
            console.log(resp.data);
            if (!resp.data) {
              const errMsg = "Data not found";
              setState({
                error: errMsg,
              });
              toast.error(errMsg);
              return;
            }
            setState({ data: resp.data });
          }
        } catch (err) {
          const errMsg =
            err && err.response ? err.response.data : "Unknown error";
          setState({
            error: errMsg,
          });
          toast.error(errMsg);
        }

        setState({ isLoading: false });
      },
  },
  // optional, mostly used for easy debugging
  name: "getScheduleService",
});

export const useScheduleStore = createHook(Store);
